import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeMarketList = (data) => {
	return {
		type: Types.STORE_MARKET_LIST,
		payload: data
	};
};

export const fetchMarketList = () => async (dispatch) => {
	await ApiClient.GET('getMarket').then((response) => {
		dispatch(storeMarketList(response.data));
	});
};
